import React from 'react';

import { Box, ButtonV2, Flex, TextV2 } from '@withjoy/joykit';
import { Link } from '@react-router';
import {
  StyledGrid,
  StyledGridItem,
  StyledGridItemCtaContainer,
  StyledGridItemImage,
  StyledGridItemImageContainer,
  StyledSectionRoot,
  gridItemCtaContainerStyles,
  gridItemImageContainerStyles,
  gridItemImageStyles,
  gridStyles,
  sectionRootStyles
} from './DepartmentNavSection.styles';

import { useTranslation } from '@shared/core';
import { useIsMobileOrTablet } from '@shared/utils/media/useMediaScreens';
import { useShopStorefrontContext } from '../../../../components/ShopStorefrontProvider';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { DepartmentNavSectionData } from '../../../../components/ShopStorefrontProvider/storefront.config.types';
import { useCatalogLoggingContext } from '../../../../Catalog.logging';

const DepartmentGrid = ({}: DepartmentNavSectionProps) => {
  const { config } = useShopStorefrontContext();
  const { t } = useTranslation('catalogRegistry');

  const isMobileOrTablet = useIsMobileOrTablet();
  const { trackCategoryNavigateAction } = useCatalogLoggingContext();

  const handleOnLinkClick = useEventCallback((dep: DepartmentNavSectionData[number]) => {
    trackCategoryNavigateAction({
      category: dep,
      navigationSource: 'departmentNavSection'
    });
  });

  return (
    <StyledGrid as="ul" __css={gridStyles}>
      {config.departmentNavSectionData.map(dep => {
        const exploreCategoryTitle = isMobileOrTablet ? dep.title : t('departmentNavSection', 'exploreCategory')({ categoryTitle: dep.title });
        return (
          <StyledGridItem
            as="li"
            key={dep.id}
            role="group"
            __css={{
              cursor: 'pointer'
            }}
          >
            <Box
              as={Link}
              to={dep.publicUrlPath}
              onClick={() => {
                handleOnLinkClick(dep);
              }}
            >
              <StyledGridItemImageContainer as="span" __css={gridItemImageContainerStyles}>
                <StyledGridItemImage
                  as="span"
                  style={{
                    backgroundImage: `url('${dep.imageUrl}')`
                  }}
                  __css={gridItemImageStyles}
                />
              </StyledGridItemImageContainer>
              <StyledGridItemCtaContainer as="span" __css={gridItemCtaContainerStyles}>
                <ButtonV2
                  as="span"
                  variant="outline"
                  intent="neutral"
                  aria-label={exploreCategoryTitle}
                  _groupHover={{
                    backgroundColor: 'buttonOutlineNeutralFillHover'
                  }}
                  _groupActive={{
                    backgroundColor: 'buttonOutlineNeutralFillPress'
                  }}
                >
                  {exploreCategoryTitle}
                </ButtonV2>
              </StyledGridItemCtaContainer>
            </Box>
          </StyledGridItem>
        );
      })}
    </StyledGrid>
  );
};

type DepartmentNavSectionProps = {};

export const DepartmentNavSection = (props: DepartmentNavSectionProps) => {
  const { t2 } = useTranslation('catalogRegistry');

  return (
    <StyledSectionRoot as="section" marginBottom={104} __css={sectionRootStyles}>
      <Flex justifyContent="center" alignItems="center">
        <TextV2 typographyVariant={['HedMobile32', null, 'Hed56']}>{t2('departmentNavSection', 'title')}</TextV2>
      </Flex>
      <DepartmentGrid />
    </StyledSectionRoot>
  );
};
